import hrvenueService from '../../services/hrvenue.service';

export default {
  namespaced: true,
  state: {
    deferredPrompt: null,
    publishableKey: '',
    showPricingButton: true,
    userList: [],
    isLoading: false,
    isLoaded: false,
  },

  // getters
  getters: {
    getDeferredPrompt: (state) => state.deferredPrompt,
    getPublishableKey: (state) => state.publishableKey,
    getShowPricingButton: (state) => state.showPricingButton,
    getUserList: (state) => state.userList,
  },

  // mutations
  mutations: {
    setDeferredPrompt (state, value) {
      state.deferredPrompt = value;
    },
    setPublishableKey (state, value) {
      state.publishableKey = value;
    },
    setShowPricingButton (state, value) {
      state.showPricingButton = value;
    },
    SET_USER_LIST(state, users) {
      state.userList = users;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_LOADED(state, isLoaded) {
      state.isLoaded = isLoaded;
    },
  },
  // actions
  actions: {
    callSetDeferredPrompt (context, value) {
      context.commit('setDeferredPrompt', value);
    },
    async fetchUserList({ commit, state }, params = {}) {
      if (state.isLoaded && !params.force) return state.userList;

      if (state.isLoading) return;

      try {
        commit('SET_LOADING', true);
        const response = await hrvenueService.getUsers();
        if (response && response.list) {
          commit('SET_USER_LIST', response.list);
          commit('SET_LOADED', true);
        }
        return response?.list || [];
      } catch (error) {
        return [];
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
